import React, { useEffect } from "react";

import darkLogo from "../../assets/darkLogo.png";
import lightLogo from "../../assets/logo.png";
import gif500 from "../../assets/errors/gif500.gif";
import { useAppContext } from "../../context/AppContext";

const Error500 = () => {
  const context  = useAppContext();
  const dark = localStorage.getItem('appDarkMode')

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
  }, [context]);
  return (
    <div
      className="d-flex justify-content-center"
      style={{ height: "100vh", overflow: "hidden", backgroundColor: dark === 'false' ? "#F0F4F8" : "#161A1D" }}
    >
      <div className="col-md-6 d-flex flex-column justify-content-center align-items-center">
        <img src={dark === 'false' ? darkLogo : lightLogo} width={250} alt="logo" className="position-absolute" style={{top: '30px'}}/>
        <img
          src={gif500}
          alt="error"
          width="80%"
          style={{ filter: "hue-rotate(327deg)" }}
        />
        <h1 className="text-center" style={{fontSize: "40px"}}>
          Erro 500
        </h1>
        <h2 className="text-center">
          Ooops! Ocorreu um erro no servidor, tente novamente mais tarde
        </h2>
      </div>
    </div>
  );
};

export default Error500;
